import createStore from './createStore'

export default createStore(window.__INITIAL_STATE__);
